export const WhatsAppGreeting = () => (
  <div data-testid="whatsapp-greeting" className="fixed bottom-[112px] left-4 sm:left-6 z-[89] bg-white text-background px-4 py-2.5 rounded-2xl rounded-bl-sm shadow-2xl max-w-[230px] animate-[fadeIn_0.3s_ease-out]">
    <p className="text-[13px] font-medium leading-snug">Sorularinizi sormak icin yazin!</p>
    <span className="absolute -bottom-[6px] left-5 w-3 h-3 bg-white rotate-45" />
  </div>
);